import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent, Typography, Button, Box, Grid, Chip } from '@mui/material';
import { styled } from '@mui/system';
import logoHorizontal from "../../../assets/logoHorizontal.png"
import QRGenerator from '../common/qrGenerator';
import colors from '../../../config/colors';
import * as apiService from '../../../api'
import { getColorPlanByIdTipoPlan } from '../../utils/helpers';
import html2canvas from 'html2canvas';
import DownloadIcon from '@mui/icons-material/Download';

const StyledCard = styled(Card)({
  maxWidth: 600,
  borderRadius: 16,
});

const Header = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const Title = styled(Typography)({
  color: '#4caf50',
  fontWeight: 'bold',
});

const Regimen = styled(Typography)({
    fontWeight: 'bold',
});

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const StyledButton = styled(Button)({
  backgroundColor: '#4caf50',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#45a049',
  },
});

const baseURL = process.env.REACT_APP_API_URL

const qrStyle = {
  dotsOptions: {
    color: colors.primaryDark,
    type: 'rounded'
  },
  cornersSquareOptions: {
    color: colors.primaryDark,
  },
  cornersDotOptions: {
    color: colors.primaryDark,
  },
  backgroundOptions: {
    color: '#fff',
  }
};

const CarneAfiliado = ({
    infoAfiliado,
    regimen,
    planComplementario,
}) => {

    const [idPlan, setIdPlan] = useState(0);
    const captureRef = useRef(null);

    function Capitalize(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    }
    const nombreCompleto = Capitalize(
      `${infoAfiliado.nombres} ${infoAfiliado.apellidos}`,
    );

    const obtenerIdTipoPlan = async () => {
      const data =  await apiService.afiliado.getAfiliado(infoAfiliado.idAfiliado).then((res) => {
        return res.data.result.datosAfiliacion
      })
      if(data){
        setIdPlan(data[0].idTipoPlan)
      }
    }

    useEffect(() => {
      obtenerIdTipoPlan()
    },[infoAfiliado])
    
    const captureDiv = async () => {
      try {
        downloadClick();
      } catch (error) {
        console.error('Error capturando:', error);
       
      }
    };
    const downloadClick = () => {
      html2canvas(captureRef.current).then(canvas => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'CarnetDigital.png';
        link.click();
      });
    };
  
    const isUltraPlan = (planComplementario ?? '').toLowerCase().includes('ultra');

    return (
      <>
        <StyledCard sx={isUltraPlan ? {
          background: 'linear-gradient(170deg, #0d0d0d 0%, #1c1c1c 55%, #262626 100%)',
          border: 'none',
          boxShadow: `0 20px 60px rgba(0,0,0,0.7)`,
        } : {}}>
          <CardContent sx={{ p: isUltraPlan ? '0 !important' : undefined }}>
            {/* Shimmer strip */}
            {isUltraPlan && (
              <Box sx={{
                height: 1,
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%)',
              }} />
            )}

            <Grid ref={captureRef} padding={2}>
              <Header mb={2}>
                {isUltraPlan ? (
                  <img
                    src='/Ultra_PNG/SeNaSa_Ultra_Logo-04.png'
                    alt="SeNaSa Ultra Logo"
                    style={{ height: 34, width: 'auto' }}
                    onError={(e) => { e.target.src = logoHorizontal; }}
                  />
                ) : (
                  <img src={logoHorizontal} alt="SeNaSa Logo" width={100}/>
                )}
                {isUltraPlan ? (
                  <Box sx={{
                    px: 1.5, py: 0.4,
                    display: 'flex', alignItems: 'center', gap: 0.6,
                  }}>
                  </Box>
                ) : (
                  <Regimen variant="subtitle1" style={{ color: getColorPlanByIdTipoPlan(idPlan) }}>
                    {planComplementario}
                  </Regimen>
                )}
              </Header>

              <Typography variant="h6" sx={{ color: isUltraPlan ? 'rgba(255,255,255,0.55)' : 'inherit' }}>
                {Capitalize(infoAfiliado.tipoAfiliado)}
              </Typography>
                      <Title sx={{ color: isUltraPlan ? '#e0e0e0 !important' : undefined }}>
                        <strong>{nombreCompleto}</strong>
                      </Title>
              <Typography component="div">
                <hr style={{ borderColor: isUltraPlan ? 'rgba(255,255,255,0.08)' : undefined }} />
              </Typography>

              <ContentBox>
                <Grid display={'flex'} justifyContent={'space-between'}>
                  <Grid>
                    <Typography variant="body2" sx={{ color: isUltraPlan ? 'rgba(255,255,255,0.85)' : 'inherit' }}>
                      <Title sx={{ color: isUltraPlan ? '#e0e0e0 !important' : undefined }}>
                        <strong>{infoAfiliado.idAfiliado}</strong>
                      </Title>
                      Número Afiliado
                    </Typography>
                    <Typography variant="body2" sx={{ color: isUltraPlan ? 'rgba(255,255,255,0.85)' : 'inherit' }}>
                      <Title sx={{ color: isUltraPlan ? '#e0e0e0 !important' : undefined }}>
                        <strong>{infoAfiliado.cedula == null ? 'N/A' : infoAfiliado.cedula}</strong>
                      </Title>
                      Cédula
                    </Typography>
                    <Typography variant="body2" sx={{ color: isUltraPlan ? 'rgba(255,255,255,0.85)' : 'inherit' }}>
                      <Title sx={{ color: isUltraPlan ? '#e0e0e0 !important' : undefined }}>
                        <strong>{infoAfiliado.nss}</strong><br />
                      </Title>
                      NSS
                    </Typography>
                    <Typography variant="body2" sx={{ color: isUltraPlan ? 'rgba(255,255,255,0.85)' : 'inherit' }}>
                      <Title sx={{ color: isUltraPlan ? '#e0e0e0 !important' : undefined }}>
                        <strong>{regimen}</strong><br />
                      </Title>
                      Régimen
                    </Typography>
                  </Grid>
                  <Grid padding={2}>
                    <Box sx={isUltraPlan ? {
                      p: 1, borderRadius: '10px',
                      background: '#1a1a1a',
                      border: '1px solid rgba(255,255,255,0.07)',
                    } : {}}>
                      <QRGenerator
                        data={`${baseURL}afiliado/verificar/afiliado?CodigoAfiliado=${infoAfiliado.idAfiliado}`}
                        options={isUltraPlan ? {
                          dotsOptions: { color: '#d0d0d0', type: 'rounded' },
                          cornersSquareOptions: { color: '#d0d0d0' },
                          cornersDotOptions: { color: '#d0d0d0' },
                          backgroundOptions: { color: 'transparent' },
                        } : qrStyle}
                        width={150}
                        height={150}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </ContentBox>
            </Grid>

            <Grid container spacing={2} display={'flex'} justifyContent="center">
              <Grid item mt={3} mb={isUltraPlan ? 2 : 0}>
                <StyledButton
                  id="btn-descargar-carne"
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={captureDiv}
                  sx={isUltraPlan ? {
                    background: 'linear-gradient(135deg, #2a2a2a, #383838)',
                    color: '#e0e0e0',
                    fontWeight: 700,
                    letterSpacing: 1,
                    border: `1px solid rgba(255,255,255,0.12)`,
                    borderRadius: '10px',
                    px: 4,
                    '&:hover': { background: 'linear-gradient(135deg, #333, #444)' },
                  } : {}}
                >
                  Descargar
                </StyledButton>
              </Grid>
            </Grid>
          </CardContent>
        </StyledCard>
      </>
    );

    return (
      <>
        <StyledCard sx={isUltraPlan ? {
          background: uBg,
          border: 'none',
          boxShadow: `0 20px 60px rgba(0,0,0,0.7), 0 2px 8px rgba(0,0,0,0.5)`,
        } : {}}>
          <CardContent sx={{ p: isUltraPlan ? '0 !important' : undefined }}>
            {/* ── TOP ACCENT STRIP (ultra only) ── */}
            {isUltraPlan && (
              <Box sx={{
                height: 2,
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.25) 50%, transparent 100%)',
              }} />
            )}

            <Box ref={captureRef} sx={{ p: 3 }}>
              {/* ── HEADER ── */}
              <Header mb={isUltraPlan ? 2.5 : 2}>
                {isUltraPlan ? (
                  <img
                    src='/Ultra_PNG/SeNaSa_Ultra_Logo-04.png'
                    alt="SeNaSa Ultra Logo"
                    style={{ height: 34, width: 'auto' }}
                    onError={(e) => { e.target.src = logoHorizontal; }}
                  />
                ) : (
                  <img src={logoHorizontal} alt="SeNaSa Logo" width={100}/>
                )}
                {isUltraPlan ? (
                  <Box sx={{
                    px: 1.5, py: 0.4,
                    borderRadius: '20px',
                    background: uBadgeBg,
                    border: `1px solid ${uBadgeBorder}`,
                    display: 'flex', alignItems: 'center', gap: 0.6,
                  }}>
                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', background: '#888' }} />
                    <Typography sx={{ color: '#c8c8c8', fontWeight: 700, fontSize: 11, letterSpacing: 2 }}>
                      ULTRA
                    </Typography>
                  </Box>
                ) : (
                  <Regimen variant="subtitle1" style={{ color: getColorPlanByIdTipoPlan(idPlan) }}>
                    {planComplementario}
                  </Regimen>
                )}
              </Header>

              {/* ── TIPO AFILIADO ── */}
              <Typography variant="h6" sx={{
                color: isUltraPlan ? 'rgba(255,255,255,0.55)' : 'inherit',
                fontSize: isUltraPlan ? 13 : undefined,
                textTransform: isUltraPlan ? 'uppercase' : undefined,
                letterSpacing: isUltraPlan ? 1.5 : undefined,
                mb: isUltraPlan ? 0.25 : undefined,
              }}>
                {Capitalize(infoAfiliado.tipoAfiliado)}
              </Typography>

              {/* ── NOMBRE ── */}
              <Typography sx={{
                color: isUltraPlan ? uValue : '#4caf50',
                fontWeight: 700,
                fontSize: isUltraPlan ? 18 : undefined,
                mb: 1,
              }}>
                {nombreCompleto}
              </Typography>

              {/* ── DIVIDER ── */}
              <Box sx={{ height: 1, background: isUltraPlan ? uSeparator : '#e0e0e0', mb: 2 }} />

              {/* ── DATA + QR ── */}
              <Grid display='flex' justifyContent='space-between' alignItems='flex-start'>
                {/* Data fields */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: isUltraPlan ? 1 : 0.5 }}>
                  {[
                    { label: 'Número Afiliado', value: infoAfiliado.idAfiliado },
                    { label: 'Cédula', value: infoAfiliado.cedula ?? 'N/A' },
                    { label: 'NSS', value: infoAfiliado.nss },
                    { label: 'Régimen', value: regimen },
                  ].map(({ label, value }) => (
                    isUltraPlan ? (
                      <Box key={label} sx={{
                        px: 1.5, py: 0.75,
                        borderRadius: '8px',
                        background: uSurface,
                        border: `1px solid rgba(255,255,255,0.05)`,
                      }}>
                        <Typography sx={{ color: uLabel, fontSize: 10, letterSpacing: 0.8, textTransform: 'uppercase' }}>
                          {label}
                        </Typography>
                        <Typography sx={{ color: uValue, fontWeight: 700, fontSize: 14, lineHeight: 1.3 }}>
                          {value}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography key={label} variant="body2">
                        <Title><strong>{value}</strong></Title>
                        {label}
                      </Typography>
                    )
                  ))}
                </Box>

                {/* QR */}
                <Box sx={{ p: 1 }}>
                  <Box sx={isUltraPlan ? {
                    p: 1.5,
                    borderRadius: '12px',
                    background: '#1a1a1a',
                    border: `1px solid rgba(255,255,255,0.08)`,
                  } : {}}>
                    <QRGenerator
                      data={`${baseURL}afiliado/verificar/afiliado?CodigoAfiliado=${infoAfiliado.idAfiliado}`}
                      options={isUltraPlan ? {
                        dotsOptions: { color: '#d0d0d0', type: 'rounded' },
                        cornersSquareOptions: { color: '#d0d0d0' },
                        cornersDotOptions: { color: '#d0d0d0' },
                        backgroundOptions: { color: 'transparent' },
                      } : qrStyle}
                      width={130}
                      height={130}
                    />
                  </Box>
                </Box>
              </Grid>
            </Box>

            {/* ── FOOTER / BUTTON ── */}
            <Box sx={{
              px: 3, pb: 3, pt: 1,
              display: 'flex', justifyContent: 'center',
              borderTop: isUltraPlan ? `1px solid ${uSeparator}` : 'none',
              mt: isUltraPlan ? 0 : 2,
            }}>
              <Button
                id="btn-descargar-carne"
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={captureDiv}
                sx={isUltraPlan ? {
                  background: 'linear-gradient(135deg, #2a2a2a, #383838)',
                  color: '#e0e0e0',
                  fontWeight: 700,
                  letterSpacing: 1,
                  border: `1px solid rgba(255,255,255,0.12)`,
                  borderRadius: '10px',
                  px: 4,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #333, #444)',
                  },
                } : {
                  backgroundColor: '#4caf50',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#45a049' },
                }}
              >
                Descargar
              </Button>
            </Box>
          </CardContent>
        </StyledCard>
      </>
    );
};

export default CarneAfiliado;
